import { render, staticRenderFns } from "./LabReportGlobalFilter.vue?vue&type=template&id=5d512c96&scoped=true&lang=html&"
import script from "./LabReportGlobalFilter.vue?vue&type=script&lang=js&"
export * from "./LabReportGlobalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d512c96",
  null
  
)

export default component.exports